import { AiOutlineClose } from "react-icons/ai";
import { FiMinus } from "react-icons/fi";
import { FiPlus } from "react-icons/fi";
import { useState, useContext } from "react";
import WithAuthentication from "Authentication/AuthenticationContext.ts";
import { addCommas } from "@persian-tools/persian-tools";
import toast from "react-hot-toast";
import logo from "assets/images/sitelogo.svg";
import { sendRequestAPI2 } from "hooks/useAxios";
import toastFunction from "utils/toast";
export default function ShoppingListItem({
  items,
  setItems,
  editCartItems,
  updateCartItemsFunc,
}) {
  // console.log("items", items);
  return items?.map((value, index) => {
    // console.log("item map", value);
    return (
      <ItemShoppingList
        img={value.url}
        main_discount={value.main_discount}
        name={value.title}
        text={value.description}
        color={value.hex}
        colorName={value.color_title}
        price={value.main_price}
        setItems={setItems}
        items={items}
        index={index}
        number={+value.itemcount}
        amountDiscount={
          value.isGroup == "1"
            ? value.price_info[0].from_price
            : value.main_discount
        }
        editCartItems={editCartItems}
        isGroup={value.isGroup}
        businessName={value.business_info.title}
        product_id={value.product_id}
        rangeId={value.price_info[0].id}
        priceId={value.SaleConditionId}
        updateCartItemsFunc={updateCartItemsFunc}
        cartItemId={value.id}
        // nameSupplier={value.supplier}
        // typeSale={value.sale}
      ></ItemShoppingList>
    );
  });
}
export function ItemShoppingList({
  img,
  name,
  text,
  color,
  colorName,
  price,
  index,
  setItems,
  items,
  number,
  isGroup,
  amountDiscount,
  editCartItems,
  businessName,
  product_id,
  priceId,
  rangeId,
  updateCartItemsFunc,
  cartItemId,
  main_discount,
  // nameSupplier,
  // typeSale
}) {
  // async function Plus() {
  //   if (await editCartItems("Increase", items[index].id)) {
  //     setItems((prev) => {
  //       console.log("prev", prev, index);

  //       return prev.map((value, index2) => {
  //         if (index2 == index) {
  //           value.itemcount++;
  //           return value;
  //         }
  //         return value;
  //       });
  //     });
  //   }
  // }
  const auth = useContext(WithAuthentication);
  //function mines
  // async function Mines() {
  //   if (await editCartItems("Decrease", items[index].id)) {
  //     if (number > 1) {
  //       setItems((prev) => {
  //         let temp = [...prev];
  //         temp[index].itemcount = temp[index].itemcount - 1;
  //         return [...temp];
  //       });
  //     }
  //   }
  // }
  // const RemoveCounter = async (items) => {
  //   console.log(
  //     "await editCartItems",
  //     await editCartItems("drop", items[index].id)
  //   );
  //   if (await editCartItems("drop", items[index].id)) {
  //     let newArray = items.filter((value, index2, array) => {
  //       if (index == index2) {
  //         return false;
  //       } else {
  //         return true;
  //       }
  //     });
  //     setItems([...newArray]);
  //   }
  // };
  // (productId, SaleConditionId, isGroup)
  const addCartItem = (productId, priceId, rangeId, isGroup) => {
    if (auth.userInfo.userType == -1) {
      toastFunction("error", " لطفا ابتدا لاگین کنید.");
    } else {
      sendRequestAPI2("addcartitem", {
        product_id: productId,
        SaleConditionId: isGroup == "1" ? rangeId : priceId,
        isGroup: isGroup,
      }).then((data) => {
        console.log("tgsdftds", data);
        if (data.data.status == 1) {
          toastFunction("success", " محصول با موفقیت به سبد خرید اضافه شد.");

          updateCartItemsFunc();
        } else if (data.data.status == -3) {
          toastFunction("error", " موجودی محصول به پایان رسیده است.");
        } else if (data.data.status == -2) {
          toastFunction("error", "شماحداکثر خرید این محصول را انجام دادید .");
        } else {
          toastFunction(
            "error",
            "متاسفانه مشکلی در افزودن به سبد خرید به وجود آمده است."
          );
        }
      });
    }
  };
  const reduceCartItem = (cartItem_id) => {
    sendRequestAPI2("reducecartitem", { cartitem_id: cartItem_id }).then(
      (e) => {
        if (e.data.status == 1) {
          updateCartItemsFunc();
        } else {
          toastFunction(
            "error",
            "کاهش از سبد خرید با مشکل مواجه شد لطفا دوباره امتحان کنید."
          );
        }
      }
    );
  };

  return (
    <div
      className="d-flex flex-wrap justify-content-between p-4"
      style={{ borderBottom: "2px solid #f1eff0" }}
    >
      <div
        className="col-6 col-sm-4 col-md-2"
        style={{
          textAlign: "right",
          alignSelf: "right",
        }}
      >
        <img
          style={{
            width: "100px",
            height: "100px",
            borderRadius: "10px",
          }}
          src={"http://marketgroup.tatdemo.ir/" + img}
        ></img>
      </div>
      <div
        className="col-6 col-sm-5 col-md-3"
        style={{
          paddingTop: "20px",
        }}
      >
        <div>
          <p style={{ fontSize: "12px", color: "#a3a1a2" }}>{name}</p>
        </div>
        <div
          style={{
            width: "150px",
          }}
        >
          <p
            style={{
              fontSize: "12px",
              color: "#5d616f",
              fontWeight: "bold",
              overflow: "hidden",
              whiteSpace: "nowrap",
              textOverflow: "ellipsis",
            }}
          >
            {text}
          </p>
        </div>
      </div>
      <div
        className="d-flex  col-6 col-sm-5 col-md-6"
        style={{ textAlign: "center", alignSelf: "center" }}
      >
        {/* <div
          style={{
            backgroundColor: color != undefined ? color : "white",
            borderRadius: "50%",
            width: "20px",
            height: "20px",
            border: "1px solid #A9A9A9",
          }}
        ></div> */}
        <span style={{ marginRight: "15px" }}>{colorName}</span>
        <span style={{ marginRight: "15px" }}>{businessName}</span>
        <span style={{ marginRight: "15px" }}>
          {" "}
          {isGroup == "1" ? "خرید گروهی" : "خرید تکی"}
        </span>
      </div>
      <div
        className="d-flex col-4 col-sm-4 col-md-2 "
        style={{ textAlign: "center", alignSelf: "center" }}
      >
        <span
          style={{ marginLeft: "10px", cursor: "pointer", marginTop: "8px" }}
        >
          <button
            // onClick={Plus}
            onClick={(e) => {
              addCartItem(product_id, priceId, rangeId, isGroup);
            }}
            style={{ border: "none", backgroundColor: "#f9f7f8" }}
          >
            <FiPlus></FiPlus>
          </button>
        </span>

        <div
          style={{
            backgroundColor: "f9f7f8",
            width: "30px",
            height: "30px",
            padding: "10px",
            textAlign: "center",
          }}
        >
          <p>{number}</p>
        </div>
        <span
          style={{ marginRight: "10px", cursor: "pointer", marginTop: "8px" }}
        >
          <button
            onClick={() => {
              reduceCartItem(cartItemId);
            }}
            style={{ border: "none", backgroundColor: "#f9f7f8" }}
          >
            <FiMinus></FiMinus>
          </button>
        </span>
      </div>
      <div
        className="col-4 col-sm-4 col-md-2"
        style={{ textAlign: "center", alignSelf: "center" }}
      >
        <p style={{ color: "#e55c75", padding: "0", margin: "0" }}>
          <del>
            {(isGroup != "1" && main_discount != "") ||
              (main_discount != "0" ? addCommas(price.toLocaleString()) : "")}
          </del>
          <p>{isGroup == "1" && addCommas(price.toLocaleString())}</p>
          {}
          {/* <del>{price.toLocaleString()}</del> */}
        </p>
        <p style={{ color: "#e55c75", padding: "0", margin: "0" }}>
          {isGroup != "1" && (price - main_discount).toLocaleString()}
        </p>
      </div>
      {/* <div
        className="col-1 col-sm-4 col-md-1"
        style={{ textAlign: "center", alignSelf: "center" }}
      >
        <button
          style={{ border: "none", backgroundColor: "#f9f7f8" }}
          onClick={() => {
            RemoveCounter(items);
          }}
        >
          <AiOutlineClose></AiOutlineClose>
        </button>
      </div> */}
    </div>
  );
}
